import { render, staticRenderFns } from "./modal-discount-set.vue?vue&type=template&id=d036ee90&scoped=true&"
import script from "./modal-discount-set.vue?vue&type=script&lang=js&"
export * from "./modal-discount-set.vue?vue&type=script&lang=js&"
import style0 from "./modal-discount-set.vue?vue&type=style&index=0&id=d036ee90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d036ee90",
  null
  
)

export default component.exports